import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg my-10">
      <h1 className="text-3xl font-bold text-center text-gray-800 mb-6 mt-10">Privacy Policy</h1>
      <p className="text-sm text-gray-600 text-center">Effective Date: April 1, 2025</p>

      <div className="mt-6 space-y-6">
        <section>
          <p className="text-gray-600">
            Welcome to <strong>The Best Cab by Bharat Tours & Travels</strong>. Your privacy is important to us. 
            This Privacy Policy explains how we collect, use, disclose, and protect your personal information 
            when you visit our website or use our services.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-700">1. Information We Collect</h2>
          <ul className="list-disc pl-5 text-gray-600">
            <li><strong>Personal Information</strong> - Name, email address, phone number, and payment details when you book a ride or tour.</li>
            <li><strong>Location Data</strong> - GPS or location-based data to provide accurate ride services.</li>
            <li><strong>Usage Data</strong> - Information about how you interact with our website, including IP address, browser type, and pages visited.</li>
            <li><strong>Cookies & Tracking Technologies</strong> - We use cookies and similar tracking tools to enhance your browsing experience.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-700">2. How We Use Your Information</h2>
          <ul className="list-disc pl-5 text-gray-600">
            <li>To provide and manage our taxi, tour, and travel services.</li>
            <li>To process payments and confirm bookings.</li>
            <li>To improve our website, services, and customer support.</li>
            <li>To send promotional offers, updates, and notifications (with your consent).</li>
            <li>To ensure security and prevent fraudulent activities.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-700">3. Sharing Your Information</h2>
          <p className="text-gray-600">We do not sell or rent your personal data. However, we may share it with:</p>
          <ul className="list-disc pl-5 text-gray-600">
            <li><strong>Service Providers & Partners</strong> - Trusted third parties who assist in processing payments, customer support, or travel services.</li>
            <li><strong>Legal Authorities</strong> - If required by law to comply with legal processes or protect our rights.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-700">4. Data Security</h2>
          <p className="text-gray-600">
            We implement strict security measures to protect your data from unauthorized access, alteration, or disclosure. 
            However, no online platform can guarantee 100% security.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-700">5. Your Rights & Choices</h2>
          <ul className="list-disc pl-5 text-gray-600">
            <li><strong>Opt-Out</strong> - You may opt out of marketing emails anytime.</li>
            <li><strong>Access & Correction</strong> - You can request access to your personal data and update or delete it.</li>
            <li><strong>Cookies Management</strong> - You can adjust your browser settings to refuse cookies.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-700">6. Third-Party Links</h2>
          <p className="text-gray-600">
            Our website may contain links to third-party websites. We are not responsible for their privacy policies or content.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-700">7. Changes to This Policy</h2>
          <p className="text-gray-600">
            We may update this Privacy Policy occasionally. Any changes will be posted with the updated effective date.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-700">8. Contact Us</h2>
          <p className="text-gray-600">If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
          <p className="mt-2 text-gray-600">
            📞 <strong>+91 92568 10874</strong> <br />
            📧 <a href="mailto:info@thebestcab.in" className="text-blue-500">info@thebestcab.in</a>
          </p>
        </section>

        <section>
          <p className="text-gray-600 font-semibold text-center mt-6">
            By using our services, you agree to this Privacy Policy. Thank you for choosing <strong>The Best Cab by Bharat Tours & Travels!</strong>
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;